<div class="d-grid gap-3">
@for(websiteUrl of websiteUrls; track websiteUrl)
{
  <div class="p-2 bg-light border">
    <label class="fw-boldtext-break">
      @switch (websiteUrl.StatusId) {
        @case (websiteUrlStatuses_Target) {
          <span class="badge bg-success rounded-pill">Target</span>
        }
        @case (websiteUrlStatuses_Supporting) {
          <span class="badge bg-primary rounded-pill">Supporting</span>
        }
        @case (websiteUrlStatuses_New) {
          <span class="badge bg-secondary rounded-pill">New</span>
        }
      }
      <a class="fas fa-external-link-square-alt me-1" [attr.href]="websiteUrl.Url" target="_blank" rel="noreferrer"></a>
      <span (click)="copyUrl(websiteUrl.Url)" class="cursor-pointer">{{websiteUrl.Url}}</span>
    </label>
    <br />
    <div class="keyword">
      @for(keyword of websiteUrl.Keywords; track keyword)
      {
        {{keyword.KeywordPhrase}}<br />
      }
    </div>
  </div>
}
</div>